import { render, staticRenderFns } from "./ColophonBlock.vue?vue&type=template&id=69ddad5c&"
import script from "./ColophonBlock.vue?vue&type=script&lang=js&"
export * from "./ColophonBlock.vue?vue&type=script&lang=js&"
import style0 from "./ColophonBlock.vue?vue&type=style&index=0&id=69ddad5c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports